import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import OrderDesk from '../components/orderdesk/OrderDesk';
import BatchPaperwork from '../components/orderdesk/BatchPaperwork';

// Order Desk: office + warehouse + managers. Team members see their own team's queues plus the
// shared ones; admins and managers (or anyone with both teams) see everything.
function OrderDeskPage() {
  const apiBase = typeof window !== 'undefined' && window.location.hostname === 'localhost' ? 'http://localhost:3001' : '';
  const { currentUser } = useAuth();
  const api = useCallback(async (path, method = 'GET', body) => {
    const token = currentUser ? await currentUser.getIdToken() : null;
    const res = await fetch(`${apiBase}${path}`, {
      method,
      headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    // Order Desk routes answer { success, message }; the v9 Production routes answer { ok, error: { message } }
    if (!res.ok || data.success === false || data.ok === false) throw new Error(data.message || data.error?.message || `Request failed (${res.status})`);
    return data;
  }, [apiBase, currentUser]);
  // fetch-style helper for the reused Restock window (it reads the Response itself)
  const authedFetch = useCallback(async (path, opts = {}) => {
    const token = currentUser ? await currentUser.getIdToken() : null;
    return fetch(`${apiBase}${path}`, { ...opts, headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...(opts.headers || {}) } });
  }, [apiBase, currentUser]);
  // Order Desk access (role + tabs + actions, set in Admin → User management → Order Desk access)
  const [access, setAccess] = useState(null);
  const [accessErr, setAccessErr] = useState(null);
  useEffect(() => {
    let alive = true;
    api('/api/v1/order-desk/access/me').then((r) => alive && setAccess(r.access)).catch((e) => alive && setAccessErr(e.message));
    return () => { alive = false; };
  }, [api]);
  if (accessErr) return <div style={{ padding: 24 }}><b>No Order Desk access</b><p>{accessErr}</p></div>;
  if (!access) return <div style={{ padding: 24 }}>Loading Order Desk…</div>;
  return <OrderDesk api={api} authedFetch={authedFetch} access={access} batchTools={BatchPaperwork} />;
}

export default OrderDeskPage;
